export const GET_LEADS_SUCCESS = 'GET_LEADS_SUCCESS';
export const GET_LEADS_FAILURE = 'GET_LEADS_FAILURE';
export const CLEAN_LEADS = 'CLEAN_LEADS';
export const LEADS_INIT_STATE = null;
